module.exports = __webpack_public_path__ + "img/partner10.8672a07f.png";